import { z } from "zod";

import { language } from "@rootreeweb/ns-helper";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";

import type { FormDefinition } from "../types.js";
import ContactCoPackingEN from "./ContactCoPackingEN.js";
import { consentTextFR } from "./shared.js";

const schema = z.object({
	Prenom: z.string(),
	"Nom de famille": z.string(),
	"E-mail": z.string().email(),
	Entreprise: z.string(),
	Language: language,
	"Numéro de téléphone": z.string(),
	"Que souhaitez-vous emballer ?": z.string(),
	"Votre emballage/packaging est-il au point ?": z.string(),
	"Si oui, quel type d'emballage ?": z.string().optional(), // TODO: Conditional with the above question // "We co-pack flexible and rigid packaging."
	"Comment avez-vous entendu parler de nous ?": z.string().optional(),
	"Quelle quantité et quel poids approximatifs cherchez-vous à remplir ?":
		z.string(),
	"Y-a-t-il autre chose que devrions savoir ?": z
		.string()
		.optional()
		.describe(
			createCustomSettings({
				textArea: true,
			}),
		),
	consentTextFR,
});

const contactCoPackingFR: FormDefinition<typeof schema.shape> = {
	signature: "14ac673fda6782ebae97582b6af50fb3d16caced325bb86e175ecfd034844615",
	formID: "contact-copacking-fr",
	schema,
	submissionOptions: {
		subject: (formState) =>
			`Contact Co-Packing Form (FR): ${formState["Prenom"]}`,
		preamble: "Submitted information",
		postamble:
			"Contact the Web Team if you have any issues with this the data in this email.",
		recipients: ["sales@rootree.ca", "web@rootree.ca"],
	},
	formOptions: {
		strings: {
			submitButton: "Envoyez-le dans!",
			success:
				"Envoi réussi ! Un membre de notre équipe de co-emballage vous contactera prochainement. Pour toute autre question, n'hésitez pas à nous contacter au 1-833-ROOTREE (766-8733).",
		},
		mapFieldsToForm: ContactCoPackingEN,
	},
};
export default contactCoPackingFR;
